module.exports = __webpack_public_path__ + "back_top.00cd931d.png";